// extracted by mini-css-extract-plugin
export var attribution = "_b0-4";
export var authorName = "_b0-5";
export var quote = "_b0-3";
export var testimonial = "_b0-2";
export var trustedBy = "_b0-0";
export var trustedByLabel = "_b0-1";